module.exports = __webpack_public_path__ + "static/media/process.2b84acd3.jpg";